import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomePageComponent } from './home-page/home-page.component';
import {ListMenuComponent} from './list-menu/list-menu.component';
import {DetailsComponent} from './list-menu/details/details.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'es',
    pathMatch: 'full'
  },
  {path: 'es', component: HomePageComponent},
  {path: 'es/:collection/:title', component: ListMenuComponent},
  {path: 'es/category/:wines/:id', component: ListMenuComponent},
  {path: 'en/category/:wines/:id', component: ListMenuComponent},
  {path: 'de/category/:wines/:id', component: ListMenuComponent},
  {path: 'en', component: HomePageComponent},
  {path: 'en/:collection/:title', component: ListMenuComponent},
  {path: 'fr', component: HomePageComponent},
  {path: 'fr/:collection/:title', component: ListMenuComponent},
  {path: 'de', component: HomePageComponent},
  {path: 'de/:collection/:title', component: ListMenuComponent},
  {path: 'description/:collection/:id', component: DetailsComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
